import { Button, Divider, Table, Tag, message } from "antd";
import { useEffect, useState } from "react";
import Url from "../../../apiCall/UrlConfig";
///redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import { useNavigate } from "react-router-dom";

const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;
const OPGNumberingMainPage = (props) => {
  let navigate = useNavigate();
  const [_paging, setPaging] = useState({ pageNumber: 1, pageSize: 10 });
  const Columns = [
    {
      title: "Patien Id",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        return <div style={{ textAlign: "center" }}>{item.patientId}</div>;
      },
    },
    {
      title: "Type",
      dataIndex: "Type",
      key: "Type",
      render: (obj, item, index) => {
        return <div style={{ textAlign: "center" }}>{item.type}</div>;
      },
    },
    {
      title: "Image",
      dataIndex: "Image",
      key: "Image",
      render: (obj, item, index) => {
        let imageObj = item;
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="maxilla"
              style={{ width: "70px" }}
            />
            <div></div>
          </>
        );
      },
    },
    {
      title: "Analyses",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        if (item?.hasOpgNumberingAnalyse) {
          return <Tag color="#87d068">Analyses Done</Tag>;
        }
        return (
          <Button onClick={() => _onClickAnalyses(item.id)}>Analyses</Button>
        );
      },
    },
  ];

  const ColumnsAnalyses = [
    {
      title: "Patient Id",
      dataIndex: "PatientID",
      key: "PatientId",
      render: (object, item) => {
        return <div>{item.patientId}</div>;
      },
    },
    {
      title: "maxilla",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        let imageObj = item?.patientImage?.find((o) => o.type == "maxilla");
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="maxilla"
              style={{ width: "70px" }}
            />
            <div></div>
          </>
        );
      },
    },
    {
      title: "lateral cephalometric ",
      dataIndex: "lateral cephalometric",
      key: "lateral cephalometric",
      render: (obj, item, index) => {
        let imageObj = item?.patientImage?.find((o) => o.type == "laterall");
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="lateral cephalometric"
              style={{ width: "70px" }}
            />
            <div></div>
          </>
        );
      },
    },
    {
      title: "Analyses",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        return <Button onClick={() => _onClickEditAnalyses(item)}>Edit</Button>;
      },
    },
  ];
  const _getListPatient = async (paging) => {
    let _paging = paging;

    if (paging == null) {
      _paging = {
        pageNumber: 1,
        pageSize: 10,
      };
    }
    let url = Url.GetListImageForOPGNumbering;

    let res = await props.actions.CallCoreServicesActionWithToken(url, _paging);

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };

  const _getListAnalysis = async () => {
    let url = Url.lateral_GetListAnalyses;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };
  useEffect(() => {
    // _getListAnalysis();

    let paging = JSON.parse(localStorage.getItem("@OpgNumbering"));
    if (paging == null) {
      paging = {
        pageNumber: 1,
        pageSize: 10,
      };
    }
    setPaging(paging);
    _getListPatient(paging);
  }, []);

  const _onClickAnalyses = (id) => {
    navigate(`./analyses/${id}`);
  };
  const _onClickEditAnalyses = (item) => {
    navigate(`/lateralchephalo/analyses/${item.patientId}/${item.id}`);
  };
  const _onChangePageSize = (pageNumber, pageSize) => {
    localStorage.setItem(
      "@OpgNumbering",
      JSON.stringify({
        pageNumber,
        pageSize,
      })
    );
    setPaging({ pageNumber, pageSize });
    _getListPatient({
      pageNumber,
      pageSize,
    });
  };

  const returnSideBar = () => {
    return (
      <div dir="ltr" style={{ height: "100%" }}>
        <div
          className="btn-gradient margin-top"
          onClick={() => navigate("./segment")}
        >
          Segment
        </div>
        <div
          className="btn-gradient margin-top"
          onClick={() => navigate("./youranalyses")}
        >
          Your Analyses
        </div>
      </div>
    );
  };
  return (
    <div dir="ltr" className="flex-row">
      <div>{returnSideBar()}</div>
      <div className="flex-1">
        <Table
          style={{ width: "100%" }}
          columns={Columns}
          dataSource={
            props.coreData[Url.GetListImageForOPGNumbering]?.[Url.action]?.data
              ?.patients
          }
          loading={
            props.coreData[Url.GetListImageForOPGNumbering]?.[Url.action]
              ?.isFetching
          }
          pagination={{
            current: _paging.pageNumber,
            pageSize: _paging.pageSize,
            total:
              props.coreData[Url.GetListImageForOPGNumbering]?.[Url.action]
                ?.data?.totalCount,
            onChange: _onChangePageSize,
          }}
          rowKey={(o) => o.id}
        />
      </div>
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OPGNumberingMainPage);
